import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
import { serviceUrl } from '../../App';

export const addusers = (obj: Object, token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `auth/register`, obj, {
    headers,
  });
};
export const editusers = (obj: Object, token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `auth/edit`, obj, {
    headers,
  });
};
export const deleteusers = (obj: Object, token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `auth/delete-users`,
    obj,
    { headers }
  );
};
export const forgetPassword = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `auth/forget-password`,
    obj,
    { headers }
  );
};
export const getusers = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `auth/users`);
};
